var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "学员备注",
        width: "602px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editRemarks overflowOuto",
        },
        [
          _c("div", { staticClass: "tipsError" }, [
            _vm._v("注：修改备注将同步到企业微信中该学员。"),
          ]),
          _c("el-input", {
            attrs: {
              maxlength: 20,
              type: "textarea",
              autosize: { minRows: 4, maxRows: 4 },
              placeholder: "请输入学员备注",
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }